var TorsoView = require('backbone-torso/modules/View');
var questionnaireSummaryItemTemplate = require('./questionnaireSummaryItemTemplate.hbs');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var QuestionnaireSummaryDetailsView = require('./QuestionnaireSummaryDetailsView');

/**
 * The QuestionnaireSummaryItemView shows a link that, when clicked, shows the Questionnaire summary in a modal.
 *
 * @class QuestionnaireSummaryItemView
 * @constructor
 * @param options {Object}
 *   @param options.questionnaireName {String} the name of the questionnaire to show this widget for.
 *   @param options.patientVecnaId {String} the patient id of the patient to get the questionnaires for.
 *   @param options.appointmentExternalId {String} the external vecna id of the patient to get the questionnaires for.
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  template: questionnaireSummaryItemTemplate,

  events: {
    'click [data-show-questionnaire]': '_showQuestionnaire'
  },

  behaviors: {
    useModal: {
      behavior: UseModalBehavior
    }
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.questionnaireName {String} the name of the questionnaire to show this widget for.
   *   @param options.questionnaireResponseId {String} the response id of the questionnaire to show this widget for.
   *   @param options.patientVecnaId {String} the patient id of the patient to get the questionnaires for.
   *   @param options.appointmentExternalId {String} the external vecna id of the patient to get the questionnaires for.
   * @override
   */
  initialize: function() {
    this._questionnaireSummaryDetailsView = new QuestionnaireSummaryDetailsView({
      model: this.model
    });
    this.registerTrackedView(this._questionnaireSummaryDetailsView);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var context = TorsoView.prototype.prepare.apply(this);
    context.questionnaireDisplayName = this._questionnaireSummaryDetailsView.getQuestionnaireDisplayName();
    return context;
  },

  /**
   * Displays the questionnaire question/answer summary modal.
   * @method _showQuestionnaire
   * @param event {jQuery.Event} the jquery event that triggered this method.
   * @private
   */
  _showQuestionnaire: function(event) {
    event.preventDefault();
    this.showModal(new ModalDialogWidget({
      alertOnly: true,
      dataViewName: 'questionnaire summary',
      className: 'brec-dialog brec-dialog--big',
      headerKey: 'appointment.detail.questionnaire.summary.title',
      yesKey: 'modalWidget.defaultCloseKey',
      trackedView: this._questionnaireSummaryDetailsView
    }));
  }
});
